import { constants as c, reducer } from './data'
import {
    addToast,
    addError,
    addWarning,
    addSuccess,
    addInfo,
    addMessage,
    setMessages,
    setQueue,
} from './actions'

export { default as middleware } from './middleware'

export const toasterReducer = reducer

// Constants are exposed as a way for toaster to send out information
// Way for the feauture to inform the surroundings of something that has happened
export const constants = {
    MOTDS_CHANGED: c.toasts.MOTDS_CHANGED, // LocalForageMiddleware
}

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    addToast,
    addError,
    addWarning,
    addSuccess,
    addInfo,
    addMessage,
    setMessages,
    useSettingsQueue: () => setQueue('settings'),
    useNormalQueue: () => setQueue(),
}



// WEBPACK FOOTER //
// ./src/features/Toaster/exports.js